import React from "react";

const DataTable = ({
  title,
  data = [],
  loading = false,
  columns = [],
  renderRow,
  totalCount,
  children,
}) => {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">
              {title} ({totalCount ?? data.length})
            </h4>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {columns.map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        No Data Found.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => renderRow(item, index))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default DataTable;
